import React from 'react';
import PropTypes from 'prop-types';
import { toCamelCase } from './UtilFunctions';

const Transformer = (data: Object, options: OptionsProps) => {
    const { remove, update } = options;

    //transform to camelCase
    Object.keys(data).forEach(function(key) {
        var newKey = toCamelCase(key);

        if (newKey !== key) {
            data[newKey] = data[key];

            // remove old key
            delete data[key];
        }
    });

    if (remove) {
        remove.forEach(function(key) {
            delete data[key];
        });
    }

    if (update) {
        Object.keys(update).map(key => data[key] = update[key]);
    }
};

Transformer.propTypes = {
    data: PropTypes.object,
    options: PropTypes.object,
};

export type OptionsProps = {
    remove?: any[];
    update?: Object;
}

export default Transformer;